import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import brandingReducer from "../features/branding/brandingSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    branding: brandingReducer
  }
});
